"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7531],{

/***/ 94761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62687);
/* harmony import */ var utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89134);
/* harmony import */ var _buttons_LabelButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23110);










var BackButton = function(_param) {
    var location = _param.location, customData = _param.customData, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "location",
        "customData"
    ]);
    var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var goBack = function(e) {
        var ref;
        e.preventDefault();
        src_services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Events.consumption.goBack */ .z.consumption.goBack,
            properties: {
                location: location
            },
            platforms: [
                "amplitude"
            ]
        });
        var ref1;
        if (customData === null || customData === void 0 ? void 0 : customData.pageLink) {
            router.push(customData.pageLink);
        } else if (((ref1 = window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0) <= 2) {
            router.push("/");
        } else {
            router.back();
        }
    };
    var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
        type: "bold",
        children: [
            utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].back */ .Z.back,
            customData ? " to " + customData.pageTitle : ""
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_buttons_LabelButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        py: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
        onClick: function(e) {
            return goBack(e);
        },
        ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(-10),
        display: "flex",
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
        _hover: {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeftSvg, {
                boxSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                cursor: "pointer",
                mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem
            }),
            (customData === null || customData === void 0 ? void 0 : customData.pageLink) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                href: "https://deepstash.com" + customData.pageLink,
                children: text
            }) : text
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 63197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ old_CollectionContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/providers/hooks/useCollection.ts
var useCollection = __webpack_require__(58397);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/providers/source/SourceProvider.tsx + 1 modules
var SourceProvider = __webpack_require__(35396);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/page-components/collection/old/CollectionSourceHighlightedIdeas.tsx
var CollectionSourceHighlightedIdeas = __webpack_require__(24311);
;// CONCATENATED MODULE: ./src/page-components/collection/old/CollectionSourceCard.tsx











var CollectionSourceCard = function(_param) {
    var source = _param.source, props = (0,_object_without_properties/* default */.Z)(_param, [
        "source"
    ]);
    var collection = (0,useCollection/* default */.Z)().collection;
    var isMobileView = (0,esm.useIsMobileView)();
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var highlightedIdeas = (0,react.useMemo)(function() {
        if (!collection || !source) return [];
        return source.ideas.slice(0, 3);
    // return source.ideas.filter(idea => !!idea.isFeaturedInCollection);
    }, [
        source.ideas
    ]);
    if (!collection) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        pos: "relative"
    }, props), {
        children: isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                    size: "large",
                    source: source
                }),
                !isLoggedIn && highlightedIdeas.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    width: "100%",
                    overflowX: "scroll",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSourceHighlightedIdeas/* default */.Z, {
                        ideas: highlightedIdeas,
                        source: source
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SourceProvider/* default */.Z, {
            source: source,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                    shouldHideCta: highlightedIdeas.length > 0,
                    showTopics: true,
                    size: "full"
                }),
                !isLoggedIn && highlightedIdeas.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSourceHighlightedIdeas/* default */.Z, {
                    ideas: highlightedIdeas,
                    source: source
                })
            ]
        })
    }), "collection-source-collapsed-".concat(source.id));
};
/* harmony default export */ var old_CollectionSourceCard = (CollectionSourceCard);

;// CONCATENATED MODULE: ./src/page-components/collection/old/CollectionContainer.tsx






var CollectionContainer = function() {
    var collection = (0,useCollection/* default */.Z)().collection;
    if (!collection) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        flexDir: "column",
        w: "100%",
        position: "relative",
        gridGap: {
            base: global/* GAP_SIZE_REM */.L3,
            md: global/* SECTION_GAP_REM */.hM
        },
        py: {
            base: global/* GAP_SIZE_REM */.L3,
            md: global/* SECTION_GAP_REM */.hM
        },
        children: collection.sources.map(function(source, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(old_CollectionSourceCard, {
                source: source,
                zIndex: collection.sources.length - index
            }, "collection-source-card-".concat(index));
        })
    });
};
/* harmony default export */ var old_CollectionContainer = (CollectionContainer);


/***/ }),

/***/ 71173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_components_breadcrumbs_BackButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94761);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50752);
/* harmony import */ var src_providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79139);
/* harmony import */ var src_providers_hooks_useCollection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58397);
/* harmony import */ var src_providers_hooks_useNsi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9182);
/* harmony import */ var src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2334);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62687);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41390);
/* harmony import */ var utils_collection_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85295);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89134);
/* harmony import */ var _components_hashtag_HashtagChipCarousel__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41914);
/* harmony import */ var _components_image_NextImage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91260);
/* harmony import */ var _ProgressBar__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(93240);




















var NUMBER_OF_CHIPS_THRESHOLD = 2;
var COMPLETED_CTA_EXTRA_PROPS = {
    _hover: {
        shadow: "none",
        cursor: "unset"
    },
    _active: {
        backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success
    }
};
var CollectionHeader = function(param) {
    var roundedHeaderImage = param.roundedHeaderImage;
    var collection = (0,src_providers_hooks_useCollection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().collection;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var isLoggedIn = (0,src_providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isLoggedIn;
    var profile = (0,src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().profile;
    var nsiDispatch = (0,src_providers_hooks_useNsi__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().nsiDispatch;
    var collectionStatus = collection && (0,utils_collection_utils__WEBPACK_IMPORTED_MODULE_12__/* .getCollectionStatus */ .t2)({
        collection: collection
    });
    var getCta = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!collection) return null;
        if (!isLoggedIn) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                size: "m",
                type: "bold",
                whiteSpace: "nowrap",
                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__/* ["default"].signUpToReadForFree */ .Z.signUpToReadForFree
            });
        }
        switch(collectionStatus){
            case types_enums__WEBPACK_IMPORTED_MODULE_11__/* .CollectionStatus.STARTED */ .Nb.STARTED:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__/* ["default"].continueReading */ .Z.continueReading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeftSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                                boxSize: {
                                    base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                                    lg: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XL.rem
                                },
                                ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                                transform: "rotate(-180deg)"
                            })
                        ]
                    });
                }
            case types_enums__WEBPACK_IMPORTED_MODULE_11__/* .CollectionStatus.NEW */ .Nb.NEW:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__/* ["default"].startReading */ .Z.startReading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeftSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                                boxSize: {
                                    base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                                    lg: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XL.rem
                                },
                                ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                                transform: "rotate(-180deg)"
                            })
                        ]
                    });
                }
            case types_enums__WEBPACK_IMPORTED_MODULE_11__/* .CollectionStatus.COMPLETED */ .Nb.COMPLETED:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.CheckFillSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.textInverted,
                                mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.textInverted,
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__/* ["default"].allRead */ .Z.allRead
                            })
                        ]
                    });
                }
            default:
                {
                    return null;
                }
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType,
        colorMode, 
    ]);
    var getCtaBackgroundColor = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!collection) return "";
        if (collection === null || collection === void 0 ? void 0 : collection.progress.completed) {
            return deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success;
        } else {
            return deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text;
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType,
        colorMode, 
    ]);
    var onClickCtaHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        if (!collection) return;
        if (!isLoggedIn) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-up"
                }
            });
        } else if (collection === null || collection === void 0 ? void 0 : collection.progress.completed) {
            return;
        } else {
            src_services_analytics__WEBPACK_IMPORTED_MODULE_10__/* .Analytics.logEvent */ .c.logEvent({
                eventName: (collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas) === 0 ? src_services_analytics__WEBPACK_IMPORTED_MODULE_10__/* .Events.consumption.collectionStartReading */ .z.consumption.collectionStartReading : src_services_analytics__WEBPACK_IMPORTED_MODULE_10__/* .Events.consumption.collectionContinueReading */ .z.consumption.collectionContinueReading,
                properties: {
                    collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
                    location: "collection-page"
                },
                platforms: [
                    "amplitude"
                ]
            });
            next_router__WEBPACK_IMPORTED_MODULE_2___default().push((0,utils_collection_utils__WEBPACK_IMPORTED_MODULE_12__/* .getNextSourceToReadFromCollectionUrl */ .e7)({
                collection: collection
            }));
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType, 
    ]);
    if (!collection) return null;
    var _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                pos: "relative",
                flexDirection: "column",
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    align: "center",
                    cursor: "pointer",
                    width: "100%",
                    justifyContent: "space-between",
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_breadcrumbs_BackButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            location: "collection"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: "/all-collections",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
                                fontWeight: "bold",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_14__/* ["default"].seeAllCollections */ .Z.seeAllCollections
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDir: "column",
                zIndex: 2,
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        mb: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .GAP_SIZE_REM */ .L3,
                        flexDirection: {
                            base: "column",
                            md: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                position: "relative",
                                alignItems: "center",
                                justifyContent: "center",
                                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(128),
                                width: isMobileView ? "100%" : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(212),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_image_NextImage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        wrapperStyle: {
                                            h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(128),
                                            w: isMobileView ? "100%" : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(212),
                                            borderRadius: roundedHeaderImage ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem : 0,
                                            cursor: "initial",
                                            transformOrigin: "center"
                                        },
                                        priority: true,
                                        imageUrl: collection.imageUrl,
                                        blurhash: collection.imageBlurhash
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                        position: "absolute",
                                        left: 0,
                                        right: 0,
                                        top: 0,
                                        bottom: 0,
                                        margin: "auto",
                                        style: {
                                            fontSize: "2.5rem",
                                            width: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .BLOCK_WIDTH_REM */ .sC,
                                            height: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .BLOCK_WIDTH_REM */ .sC,
                                            alignItems: "center",
                                            transformOrigin: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top,
                                            borderRadius: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .BLOCK_WIDTH_REM */ .sC
                                        },
                                        zIndex: 2,
                                        children: collection.emoji
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                flexDirection: "column",
                                height: "auto",
                                justifyContent: "center",
                                mt: {
                                    base: "1rem",
                                    md: 0
                                },
                                ml: {
                                    base: "0rem",
                                    md: "2rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                                        size: "h1",
                                        textSize: "xl",
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                        lineHeight: "2.25rem",
                                        fontWeight: 700,
                                        fontSize: "2rem",
                                        noOfLines: 4,
                                        children: collection.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                        size: isMobileView ? "s" : "m",
                                        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                                        display: "flex",
                                        children: (_description = collection.description) !== null && _description !== void 0 ? _description : ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        flexDirection: {
                            base: "column",
                            md: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                size: "lg",
                                width: {
                                    base: "calc(100%)",
                                    md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(212)
                                },
                                px: {
                                    base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                                    lg: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48)
                                },
                                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(54),
                                backgroundColor: getCtaBackgroundColor,
                                onClick: onClickCtaHandler
                            }, collectionStatus === types_enums__WEBPACK_IMPORTED_MODULE_11__/* .CollectionStatus.COMPLETED */ .Nb.COMPLETED ? COMPLETED_CTA_EXTRA_PROPS : {}), {
                                overflow: "hidden",
                                border: 0,
                                _hover: undefined,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                        align: "center",
                                        children: getCta
                                    }),
                                    collection.progress.totalReadIdeas > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProgressBar__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        currentValue: collection.progress.totalReadIdeas,
                                        totalValue: collection.ideaCount,
                                        flexGrow: 1,
                                        left: 0,
                                        width: "100%",
                                        bottom: 0,
                                        height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                                        borderRadius: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                                        position: "absolute",
                                        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary.darker,
                                        isPadded: true
                                    })
                                ]
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hashtag_HashtagChipCarousel__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                hashtags: collection.hashtags.map(function(hashtag) {
                                    return {
                                        name: hashtag
                                    };
                                }),
                                numberOfChipsThreshold: NUMBER_OF_CHIPS_THRESHOLD,
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                                ml: {
                                    base: 0,
                                    md: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .GAP_SIZE_REM */ .L3
                                },
                                mt: {
                                    base: utils_global__WEBPACK_IMPORTED_MODULE_13__/* .GAP_SIZE_REM */ .L3,
                                    md: 0
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionHeader);


/***/ })

}]);